const order = {
  path: 'order',
  component: resolve => require(['@/pages/admin/trading/order'], resolve)
}

export default order
